import React from 'react';

export default class SearchResult extends React.Component {

    constructor(props) {
      super(props);
      this.myScrollList = React.createRef();
	  this.state = {
        data : null
      };
    }
	
	componentDidMount () {
		this.$el = window.$(this.myScrollList.current);
		this.$el.mCustomScrollbar();
	}
	
	makeSearch() {
		return this.props.brands.filter(item => {
			if (this.props.query) {
				let query = this.props.query.toLowerCase();
				let title = item.title.toLowerCase();
				if (title.indexOf(query) === -1) return false;
			}
			if (this.props.cat_id) {
				if (item.cats.indexOf(this.props.cat_id) === -1) return false;
			}
			return true;
		});
	}

	render() {
		let list = this.makeSearch();
		return (
			<div class="chosen-category-form">
				<div class="search-results_box" ref={this.myScrollList}>
					<ul class="search-results_list">
					    {list.length===0 &&
							<li class="checkbox-block checkbox-row search-results_item">
								<label>Ничего не найдено</label>
							</li>
						}
						{list.map((item,index) => {
							return (
								<li class="checkbox-block checkbox-row search-results_item" key={index}>
									<label for={item.id}>
										<span class="text-blue"></span>{item.title}
										<input id={item.id} type="checkbox" checked={this.props.getChecked(item.id)} onChange={e => this.props.changeSelect(e, item)}/>
										<span class="checkmark"></span>
									</label>
								</li>
							);
						})}
					</ul>
				</div>
				<div class="buttons-row">
					<button class="btn" type="submit" onClick={e => this.props.changeStep('selected')}>Завершить выбор</button>
					<button class="btn white" onClick={this.props.resetSearch}>Продолжить выбор в других категориях</button>
				</div>
				<div class="text-bottom">
					Не нашли в списке свой любимый бренд или хотите предложить свою идею?<br/>
					Напишите нам на <a href="mailto:&#084;&#101;&#110;&#097;&#110;&#116;&#046;&#069;&#110;&#107;&#097;&#084;&#099;&#064;&#101;&#110;&#107;&#097;&#046;&#099;&#111;&#109;">&#084;&#101;&#110;&#097;&#110;&#116;&#046;&#069;&#110;&#107;&#097;&#084;&#099;&#064;&#101;&#110;&#107;&#097;&#046;&#099;&#111;&#109;</a>
				</div>
			</div>
		);
	}

}